import { render, staticRenderFns } from "./validation-checks.vue?vue&type=template&id=68fcad26&scoped=true&"
import script from "./validation-checks.vue?vue&type=script&lang=js&"
export * from "./validation-checks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fcad26",
  null
  
)

export default component.exports